import React from 'react';
import Card from '../../components/Card/Card';

import { US_EQUITY } from '../../utils/constants';

import styles from './USequity.css';

const USequityCard = ({ ticker }) => (
    <div className="section-container">
        {US_EQUITY.includes(ticker) && (
            <Card>
                <React.Fragment>
                    <div className="subsection">
                        <div>
                            <strong>Important Information:</strong> Read 8/09/21{' '}
                            <a
                                target="pr111920"
                                href="https://www.troweprice.com/content/dam/trowecorp/Press_Statement_USEQIQ32021_US_Mutual_Fund.pdf"
                            >
                                press release
                            </a>{' '}
                            regarding a proposal to launch a new investment
                            adviser.
                        </div>
                    </div>
                </React.Fragment>
            </Card>
        )}

        <style jsx>{styles}</style>
    </div>
);

export default USequityCard;
